/**
 * Client-facing PDF ViewModel.
 * Never includes purchase cost, margin, markup, profit, ROI or supplier data.
 */

export interface ClientPdfCompany {
  name: string
  tagline: string
  city?: string
  cnpj?: string
  phone?: string
  email?: string
  address?: string
  logoDataUrl?: string
}

export interface ClientPdfClient {
  name: string
  document?: string
  email?: string
  phone?: string
}

export interface ClientPdfItem {
  description: string
  quantity: number
  unitPrice: number
  lineTotal: number
}

export interface ClientPdfSummary {
  subtotal: number
  discountTotal: number
  shipping: number
  total: number
}

export interface ClientPdfTerms {
  payment?: string
  validity?: string
  warranty?: string
  delivery?: string
}

export interface ClientPdfDocument {
  number: string
  title: string
  issuedAtLabel: string
  statusLabel?: string
  company: ClientPdfCompany
  client: ClientPdfClient
  items: ClientPdfItem[]
  summary: ClientPdfSummary
  terms: ClientPdfTerms
  notes?: string
}

export const INTERNAL_PDF_FIELD_NAMES = [
  'purchaseCost',
  'purchasePrice',
  'purchaseTotal',
  'operationalCost',
  'operational',
  'margin',
  'marginPercent',
  'markup',
  'profit',
  'profitTotal',
  'ROI',
  'roi',
  'supplierCost',
  'supplierName',
  'supplierId',
] as const

export function buildPdfFilename(number: string): string {
  const cleaned = number.replace(/[^\w.-]+/g, '-').replace(/^-+|-+$/g, '') || 'ORC'
  return `${cleaned}-Master-Informatica.pdf`
}

export function compactText(value: string | undefined | null): string | undefined {
  const trimmed = value?.trim()
  return trimmed ? trimmed : undefined
}
